import { selectFlags } from '@app/store/selectors';
import { useAppSelector } from '@app/store/store';

export const useFlag = (flag: string) => {
  const flags = useAppSelector(selectFlags);

  return flags?.[flag];
};
